import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  align-items: center;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .view {
    width: 100%;
    max-width: 1300px;
    padding: 20px;
    flex: 1;
  }

  h1 {
    width: 100%;
    text-align: left;
    margin-bottom: 25px;
    color: #000;
  }

  @media (max-width: 750px) {
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 15px;
    }
  }
`;

export const List = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  padding: 40px 0;

  div {
    background: #fff;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    border-radius: 5px;
    margin: 10px;
    border-width: 1px;
    border-color: #f0f0f0;
    border-style: solid;

    .infos {
      display: flex;
      margin: 0;
      border: none;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 10px 15px;
    }

    img {
      width: 100%;
      max-height: 180px;
      border-width: 1px 0;
      border-color: #f0f0f0;
      border-style: solid;
    }
    p {
      font-size: 17px;
      text-align: left;
    }
  }
`;

export const InputFilter = styled.input`
  padding: 8px;
  border-radius: 5px;
  background-color: #f0f0f0;
  color: #000c;
  height: 40px;
  width: 100%;
  max-width: 450px;
  border: none;
  font-size: 16px;
`;
